module.exports = __webpack_public_path__ + "img/工商.b814ac1f.png";